import { useEffect, useRef } from 'react';

const INACTIVITY_TIMEOUT = 24 * 60 * 60 * 1000; // 24 hours
const CHECK_INTERVAL = 5 * 60 * 1000; // 5 minutes
const LAST_ACTIVE_KEY = 'lastActive';

export function useAutoLogout(logoutFn: () => void, isUserLoggedIn: boolean) {
  const isIntervalIdRef = useRef<NodeJS.Timeout | undefined>();
  const checkInactivity = () => {
    if (!isUserLoggedIn) {
      return;
    }

    const lastActiveString = localStorage.getItem(LAST_ACTIVE_KEY);
    if (lastActiveString) {
      const lastActive = parseInt(lastActiveString, 10);
      const now = Date.now();
      if (now - lastActive > INACTIVITY_TIMEOUT) {
        logoutFn();
      }
    }
  };

  const updateLastActive = () => {
    if (!isUserLoggedIn) {
      return;
    }

    localStorage.setItem(LAST_ACTIVE_KEY, Date.now().toString());
  };

  useEffect(() => {
    if (!isUserLoggedIn) {
      clearInterval(isIntervalIdRef.current);
      return;
    }

    isIntervalIdRef.current = setInterval(checkInactivity, CHECK_INTERVAL);

    const events = ['mousemove', 'keydown', 'click', 'touchstart', 'scroll'];
    events.forEach((e) => window.addEventListener(e, updateLastActive));

    updateLastActive();

    return () => {
      if (isIntervalIdRef.current) {
        clearInterval(isIntervalIdRef.current);
      }

      events.forEach((e) => window.removeEventListener(e, updateLastActive));
    };
  }, [isUserLoggedIn]);
}